/**
 * 계정복구 폼 상태 관리 Hook
 * FSD: features/account-recovery/hooks
 */

import { useState, useCallback } from "react";
import {
  AccountRecoveryFormData,
  RecoveryMode,
} from "../model/account-recovery.types";

export function useAccountRecoveryForm(mode: RecoveryMode) {
  const [formData, setFormData] = useState<AccountRecoveryFormData>({
    email: "",
    user_id: "",
    code: "",
    isEmailVerified: false,
  });

  const [isLoading, setIsLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);

  const handleChange = useCallback(
    (field: keyof AccountRecoveryFormData, value: any) => {
      setFormData((prev) => ({
        ...prev,
        [field]: value,
      }));
    },
    []
  );

  const resetForm = useCallback(() => {
    setFormData({
      email: "",
      user_id: "",
      code: "",
      isEmailVerified: false,
    });
    setEmailSent(false);
  }, []);

  return {
    formData,
    isLoading,
    emailSent,
    handleChange,
    setIsLoading,
    setEmailSent,
    resetForm,
  };
}
